import { Box, Flex } from '@rebass/grid'
import * as React from 'react'
import { Text } from 'src/elements'
import Icon from '../Icon'

const Toolbar = ({
  likes,
  discussions,
  onLikeClick,
  onDiscussionClick,
  isLiked,
  isDiscussed
}: {
  likes: number;
  discussions: number;
  onLikeClick?: () => void;
  onDiscussionClick?: () => void;
  isLiked?: boolean;
  isDiscussed?: boolean;
}) => {
  return (
    <Flex px={16} pt={12} pb={12}>
      <Box mr={12} onClick={onLikeClick}>
        <Flex>
          <Box mr={1}>
            {isLiked ? (
              <Icon type="lecture-like" />
            ) : (
              <Icon type="lecture-like-o" />
            )}
          </Box>
          <Box>
            <Text.Content>{likes} 喜歡</Text.Content>
          </Box>
        </Flex>
      </Box>
      <Box mr={12} onClick={onDiscussionClick}>
        <Flex>
          <Box mr={1}>
            {isDiscussed ? (
              <Icon type="lecture-comment" />
            ) : (
              <Icon type="lecture-comment-o" />
            )}
          </Box>
          <Box>
            <Text.Content>{discussions} 討論</Text.Content>
          </Box>
        </Flex>
      </Box>
    </Flex>
  )
}

export default Toolbar



// WEBPACK FOOTER //
// ./src/components/Material/Toolbar.tsx